import React from 'react';
import { Box } from '@chakra-ui/react';

interface FeatureCheckboxProps {
  isSelected: boolean;
}

const FeatureCheckbox = ({ isSelected }: FeatureCheckboxProps) => (
  <Box
    borderWidth="1px"
    borderRadius="lg"
    width={[4]}
    height={4}
    borderColor="black"
    bg={isSelected ? 'black' : 'white'}
  />
);

export default FeatureCheckbox;
